
import React, { Component } from 'react';
import BrandForm from '../components/BrandForm';
import BrandDetail from '../components/BrandDetail';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateBrand } from '../actions/BrandsCreators';

class BrandInfo extends Component {
  constructor(props) {
    super(props);

    this.onClickEditPencil = this.onClickEditPencil.bind(this);
    this.state = {
      isEditing: false
    };
  }

  render() {
    const brand = this.props.brand;
    
    const brandUI = !this.state.isEditing ?
      <BrandDetail brand={ brand }
       onClickEditPencil={ () => this.onClickEditPencil() } /> :
      <BrandForm
        brand={ brand }
        onCancel={ () => { this.onEditCancel() } }
        newBrand={ (newBrand) => this.onSetNewBrand(newBrand) }
      />;
    return (
      <div>{ brandUI }</div>
    );
  }

  onSetNewBrand({ nameCN, desc }) {
    this.props.updateBrand({
      id: this.props.brand.id,
      nameCN,
      descriptions: [desc]
    }, () => {
      this.setState({ isEditing: false });
    });
  }

  onClickEditPencil() {
    this.setState((prevState) => ({ isEditing: !prevState.isEditing }));
  }

  onEditCancel() {
    this.setState({ isEditing: false });
  }
}

function mapStateToProps(state, ownProps) {
  return {
    brand: state.brands.brandList[ownProps.brandId]
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateBrand }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BrandInfo);
